module.exports = __webpack_public_path__ + "static/media/HomeIC.00466679.svg";